export const FETCH_OPTIONS = "FETCH_OPTIONS";
export const SAVE_OPTIONS = "SAVE_OPTIONS";
export const RELOAD_FROM_FILE = "RELOAD_FROM_FILE";
